import React from "react";
import { useTranslation } from "react-i18next";

const StepIndicator = ({ currentStep }) => {
  const { t } = useTranslation();

  const steps = [
    { num: 1, labelKey: "customer.add.steps.step1" },
    { num: 2, labelKey: "customer.add.steps.step2" },
    { num: 3, labelKey: "customer.add.steps.step3" },
    { num: 4, labelKey: "customer.add.steps.step4" },
  ];

  return (
    <div className="mb-4">
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ position: "relative" }}
      >
        {steps.map((step, idx) => (
          <React.Fragment key={step.num}>
            <div
              className="d-flex flex-column align-items-center"
              style={{ flex: 1, position: "relative", zIndex: 2 }}
            >
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center ${
                  currentStep >= step.num ? "bg-primary text-white" : "bg-light text-muted"
                }`}
                style={{
                  width: "40px",
                  height: "40px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                {step.num}
              </div>
              <span className="small text-center">{t(step.labelKey)}</span>
            </div>
            {idx < steps.length - 1 && (
              <div
                className="flex-grow-1"
                style={{
                  height: "2px",
                  backgroundColor: currentStep >= step.num + 1 ? "#0d6efd" : "#dee2e6",
                  margin: "0 10px",
                  marginTop: "-30px",
                  zIndex: 1,
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
